import { useMemo } from 'react';

type Group = {
  id: string;
};
type DataPoint = {
  groupId?: string;
  name?: string;
};
type GetNameFunction<T> = (d: T) => string;
const compare = <T extends DataPoint>(
  groups: Group[],
  getName: GetNameFunction<T> = (d: T) => d.name || '',
): ((a: T, b: T) => number) => {
  const groupIndexMap: Record<string | number, number> = groups.reduce(
    (acc, group, index) => ({ ...acc, [group.id]: index }),
    {},
  );
  const getGroupIndex = (d: T): number => groupIndexMap[d.groupId ?? ''] ?? 1e9;
  return (a: T, b: T): number =>
    getGroupIndex(a) - getGroupIndex(b) || Intl.Collator().compare(getName(a), getName(b));
};

export default function useSortByGroup<T extends DataPoint>(data: T[], groups: Group[] = []): T[] {
  return useMemo(() => {
    return [...data].sort(compare(groups, (d: T) => d.name || ''));
  }, [data, groups]);
}
